/**
 * @generated SignedSource<<94653e896ed03bed6224bde4317d049e>>
 * @relayHash 7d1d71d1ed15f5485f19cb88d7931ac4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f073a5f410b7deb6d2d67d52ec71b6a57f832c0b906538848a206112e422fdce

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type ThemeSetterQuery$variables = {
  cloudId: string;
  projectIdOrKey: string;
  withPersistDominantColor: boolean;
};
export type ThemeSetterQuery$data = {
  readonly jira: {
    readonly mediaClientId: string | null;
    readonly mediaExternalEndpointUrl: string | null;
  };
  readonly jira_projectByIdOrKey: {
    readonly background: {
      readonly " $fragmentSpreads": FragmentRefs<"ThemeSetterBackground">;
    } | null;
    readonly canEditProjectConfig: {
      readonly canPerform?: boolean;
    } | null;
    readonly projectId: string | null;
    readonly projectType: JiraProjectType | null;
    readonly " $fragmentSpreads": FragmentRefs<"DominantColorPersister_project">;
  } | null;
};
export type ThemeSetterQuery = {
  response: ThemeSetterQuery$data;
  variables: ThemeSetterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdOrKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withPersistDominantColor"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaClientId"
    },
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaExternalEndpointUrl"
    }
  ]
},
v4 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v6 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v7 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EDIT_PROJECT_CONFIG"
  }
],
v8 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v9 = {
  "alias": "canEditProjectConfig",
  "args": (v7/*: any*/),
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "condition": "withPersistDominantColor",
      "kind": "Condition",
      "passingValue": true,
      "selections": (v8/*: any*/)
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThemeSetterQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v3/*: any*/),
        "action": "THROW"
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "background",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ThemeSetterBackground"
              }
            ]
          },
          {
            "condition": "withPersistDominantColor",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "DominantColorPersister_project"
              }
            ]
          },
          (v9/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThemeSetterQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "name": "background",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraActiveBackgroundDetailsResult"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "colorValue"
                  }
                ],
                "type": "JiraColorBackground"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "gradientValue"
                  }
                ],
                "type": "JiraGradientBackground"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraCustomBackground",
                    "kind": "LinkedField",
                    "name": "customBackground",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "mediaApiFileId"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "durationInSeconds",
                            "value": 900
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "mediaReadToken",
                        "storageKey": "mediaReadToken(durationInSeconds:900)"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "sourceType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "sourceIdentifier"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "altText"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "dominantColor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "brightness"
                      }
                    ]
                  }
                ],
                "type": "JiraMediaBackground"
              }
            ]
          },
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "condition": "withPersistDominantColor",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "canEditProjectConfig",
                "args": (v7/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f073a5f410b7deb6d2d67d52ec71b6a57f832c0b906538848a206112e422fdce",
    "metadata": {},
    "name": "ThemeSetterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "00588b44ddb7fb3712853e60101fbdba";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
